import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import foodImg from '../../assets/images/food.svg';
import transportImg from '../../assets/images/transportation.svg';
import healthImg from '../../assets/images/clinical.svg';
import employmentImg from '../../assets/images/employment.svg';
import financeImg from '../../assets/images/finance.svg';
import houseImg from '../../assets/images/housing.svg';
import otherImg from '../../assets/images/others.svg';
import eduImg from '../../assets/images/education.svg';
import wifiImg from '../../assets/images/wifi.svg';
import legalImg from '../../assets/images/legal.svg';

import caregiver from '../../assets/icons/Caregiver.svg';
import clinical from '../../assets/icons/Clinical.svg';
import digital from '../../assets/icons/Digital.svg';
import employment from '../../assets/icons/Employment.svg';
import financial from '../../assets/icons/Financial.svg';
import food from '../../assets/icons/Food.svg';
import housing from '../../assets/icons/Housing.svg';
import interpersonal from '../../assets/icons/Interpersonal.svg';
import legal from '../../assets/icons/Legal.svg';
import literacy from '../../assets/icons/Literacy.svg';
import other from '../../assets/icons/Other.svg';
import social from '../../assets/icons/Social.svg';
import transportation from '../../assets/icons/Transportation.svg';
import { dateInRequireFormate } from '../../utils/Utils';

const LegacyInfoPdf = ({ dataForPDf }) => {
    const disclaimerMargin = {
        marginTop: '18%'
    };

    const fontItalic = {
        fontStyle: 'italic'
    };

    const textColor = {
        color: '#25676D'
    };

    const orgColor = {
        color: ' #495057'
    };

    const textWrap = {
        wordBreak: 'break-word'
    };

    const iconSuze = {
        height: '30px',
        marginRight: '5px',
        marginBottom: '8px'
    };

    const handleCatgIcon = (item) => {
        if (!item) return otherImg;
        switch (true) {
            case item.includes('Employment') || item.includes('Literacy'):
                return employmentImg;
            case item.includes('Housing') || item.includes('Insecurity'):
                return houseImg;
            case item.includes('Transportation'):
                return transportImg;
            case item.includes('Education') || item.includes('Literacy'):
                return eduImg;
            case item.includes('Digital') || item.includes('Broadband'):
                return wifiImg;
            case item.includes('Legal') || item.includes('Justice'):
                return legalImg;
            case item.includes('Financial') || item.includes('Hardship'):
                return financeImg;
            case item.includes('Clinical') || item.includes('Barriers'):
                return healthImg;
            case item.includes('Food'):
                return foodImg;
            default:
                return otherImg;
        }
    };

    return (
        <>
            <div className="px-4">
                {dataForPDf?.needs?.length > 0 ? (
                    <>
                        {dataForPDf?.needs?.map((item, idx) => (
                            <div key={idx}>
                                <Card className="p-3 rounded">
                                    <div className="d-flex justify-content-between align-items-center border-bottom">
                                        <div className="d-flex align-items-center">
                                            <img src={handleCatgIcon(item?.category)} alt="" className="text-primary" style={iconSuze} />
                                            <div className="m-0 fs-2 font-weight-bold text-success mb-1 ml-3">{item?.category}</div>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        {item?.serviceOrganizations?.length > 0 ? (
                                            <>
                                                <Row>
                                                    {item?.serviceOrganizations?.map((ele, index) => (
                                                        <Col xl={6} lg={6} md={6} key={index} className="border-right mt-1">
                                                            <div>
                                                                <div className="m-0 fs-4 font-weight-bold" style={orgColor}>
                                                                    {ele?.serviceOrganizationName}
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <i className="ri-map-pin-fill text-danger fs-2"></i>
                                                                <div className="fs-4 ml-5">{ele?.location ? ele?.location : '-'}</div>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <i className="ri-phone-fill text-success fs-2"></i>
                                                                <p className="fs-4 m-0 ml-5">{ele?.phone ? ele?.phone : '-'}</p>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <i className="ri-mail-fill text-warning fs-2"></i>
                                                                <p className="fs-4 m-0 ml-5">{ele?.email ? ele?.email : '-'}</p>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <i className="ri-global-fill text-info fs-2"></i>
                                                                <a
                                                                    href={
                                                                        ele?.website?.startsWith('http')
                                                                            ? ele?.website
                                                                            : `http://${ele?.website}`
                                                                    }
                                                                    className="fs-4 m-0 ml-5 text-info"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={textWrap}
                                                                >
                                                                    {ele?.website || '-'}
                                                                </a>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <i className="ri-calendar-line text-success fs-2"></i>
                                                                <p className="fs-4 m-0 ml-5">
                                                                    {ele?.pcpAppointmentDate
                                                                        ? dateInRequireFormate(ele?.pcpAppointmentDate, 'm/d/y/hh:mm')
                                                                        : '-'}
                                                                </p>
                                                            </div>
                                                            <div className="d-flex align-items-center mt-2">
                                                                <i className="ri-sticky-note-line text-info fs-2"></i>
                                                                <p className="fs-4 m-0 ml-5" style={textWrap}>
                                                                    {ele?.notes ? ele?.notes : '-'}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </>
                                        ) : (
                                            <div className="p-2 text-center">
                                                <div>A resource is not yet available for this need.</div>
                                                <div>
                                                    As soon as your care plan is updated, we will notify you using your preferred
                                                    communication method.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            </div>
                        ))}
                    </>
                ) : (
                    <div className="p-5 text-center">
                        <div>A resource is not yet available for this need.</div>
                        <div>As soon as your care plan is updated, we will notify you using your preferred communication method.</div>
                    </div>
                )}
            </div>
            <div style={disclaimerMargin}>
                <div className="mb-3">
                    <p className="px-4" style={fontItalic}>
                        <span className="font-weight-bold mr-2">Disclaimer: </span>
                        The information provided under this care plan is intended only for informational purposes for your general knowledge
                        and is not a substitute for medical advice or treatment, or for the care that patients receive from their
                        physicians. This care plan and its health-related information and resources are not intended, and must not be taken,
                        to be the rendering of medical, nursing, or professional health care advice or services, diagnosis, or the practice
                        of medicine, nursing, or professional health care, in any jurisdiction.
                    </p>
                </div>
                <div className="mb-3">
                    <p className="px-4" style={fontItalic}>
                        Always seek the advice of your physician before beginning any new treatment or if you have any questions regarding a
                        medical condition. You should not disregard medical advice from a qualified medical professional because of
                        information you received from this program. You should seek prompt medical care for any specific health issues and
                        consult your physician before starting a new fitness regimen.
                    </p>
                </div>
                <div className="mb-3">
                    <p className="px-4" style={fontItalic}>
                        Health benefits and health insurance plans contain exclusions and limitations.
                    </p>
                </div>
                <div className="mb-3">
                    <p className="px-4" style={fontItalic}>
                        IF YOU BELIEVE YOU ARE EXPERIENCING A MEDICAL EMERGENCY, CONTACT YOUR DOCTOR OR CALL 911 IMMEDIATELY.
                    </p>
                </div>
                <div className="mb-3">
                    <p className="px-4" style={fontItalic}>
                        This disclaimer concerning medical advice shall apply to all information and materials provided by GroundGame.Health
                        Inc. or its subcontractors.
                    </p>
                </div>
            </div>
        </>
        // <div>LegacyInfoPdf</div>
    );
};

export default LegacyInfoPdf;
